<template>
  <div>
    <div
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 7.5px 10px;
      "
    >
      <button
        class="btn"
        style="font-size: 16px; color: #6c6c6c; padding: 4px; font-family: 'Inter',sans-serif;"
        @click="$router.go(-1)"
      >
        <i class="fas fa-angle-left mr-2"></i>
        Back
      </button>
      <p class="mb-0" style="font-size: 16px; color: #BEBEBE; font-weight: 600; font-family: 'Inter',sans-serif;" >
        | User Management
        <i class="fas fa-angle-right"></i>
      </p>
      <p
        class="mb-0 ml-1"
        style="font-size: 16px; color: #4B4B4B; font-weight: bold; font-family: 'Inter',sans-serif;"
      >
        {{ mode == "CREATE" ? "Create" : "Edit" }} User
      </p>
    </div>

    <!-- Your content goes here -->
    <form class="form-text">
      <div class="innerBox col mt-4">
        <div v-if="mode === 'CREATE'" class="row mt-3">
          <div class="col-6">
            <label style="font-size: 14px">Username</label>
          </div>
        </div>

        <div v-if="mode === 'CREATE'" class="row">
          <div class="col-12">
            <input
              type="text"
              v-model="form.username"
              class="searchbar"
            />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-6">
            <label style="font-size: 14px">Password</label>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <input
              type="text"
              v-model="form.password"
              class="searchbar"
            />
          </div>
        </div>

        <!-- v-if="mode === 'CREATE'" -->
        <div class="row mt-3">
          <div class="col-6">
            <label style="font-size: 14px;">Type</label>
            <b-button :id="'html-tooltip-button-title-' + circle_bg_color" variant="link" class="p-2"
                  v-b-tooltip.hover>
                  <i class="fal fa-info-circle" style="color: #E6E6E6; font-size: 14px"></i>
                </b-button>

                <b-tooltip 
                  :target="'html-tooltip-button-title-' + circle_bg_color" 
                  triggers="hover"
                  custom-class="left-aligned-tooltip" 
                  html
                >
                  <span style="color:#383838; font-weight:600;">Super Admin</span><br>
                  Dapat mengelola dan mengakses seluruh produk.
                  <br><br>
                  <span style="color:#383838; font-weight:600;">Admin</span><br>
                  Hanya dapat mengelola dan mengakses produk yang dipilih.
                </b-tooltip>

          </div>
        </div>

        <!-- v-if="mode === 'CREATE'" -->
        <div class="row">
          <div class="col-12">
            <!-- <input
                  type="text"
                  v-model="form.type"
                  class="searchbar"
                  placeholder="Type"
                /> -->
                <!-- label="name" -->
                <!-- track-by="name" -->
                <!-- :object="false" -->
            <Multiselect
              v-model="form.role"
              :options="roles"
              placeholder="Select Type"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              class="dropdown-custom"
            />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-6">
            <label style="font-size: 14px">AHM Product</label>
          </div>
        </div>

        <div>
          <!-- <label class="typo__label">Select Product Type</label> -->
          <Multiselect
            v-model="value"
            :options="options"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Product Type"
            label="name"
            track-by="name"
            :preselect-first="true"
            :disabled="isSuperAdmin"
            class="dropdown-custom"
          >
            <template #selection="{ values, search, isOpen }">
              <span
                v-if="values.length"
                v-show="!isOpen"
                >{{ values.length }} Options Selected</span
              >
            </template>
          </Multiselect>
          <!-- <pre class="language-json"><code>{{ value }}</code></pre> -->
        </div>

        <div class="row mt-3">
          <div class="col-6">
            <label style="font-size: 14px">Status</label>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <Multiselect
              v-model="form.status"
              :options="statusOptions"
              label="label"
              track-by="value"
              placeholder="Select Status"
              :multiple="false"
              class="dropdown-custom"
            />
          </div>
        </div>

        <div class="filter row mt-5 d-flex justify-content-end">
          <div class="col-lg-2 col-md-6 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary w-100"
              style="
                font-size: 12px;
                background-color: #267ce5;
                border-color: #267ce5;
              "
              @click="submitForm()"
            >
              {{ mode == "CREATE" ? "Create User" : "Update User" }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import router from "../../../Options/router";
import axios from "axios";
// import DateRangePicker from 'vue-daterange-picker';

export default {
  metaInfo: {
    title: "Create User",
  },
  data() {
    return {
      matched_id: null,
      user: this.$store.getters.currentUser,
      value: [],
      options: [],
      roles: [],
      mode: "CREATE",
      updateId: null,
      form: {
        username: "",
        password: "",
        role: "",
        product_category: [],
        status: "",
      },
      statusOptions: [
        { label: "ACTIVE", value: 1 },
        { label: "INACTIVE", value: 0 }
      ],
    };
  },
  components: { Multiselect },
  computed: {
      isSuperAdmin() {
      if (!this.form.role) return false;
      if (typeof this.form.role === "object") {
        return this.form.role.name === "SUPER ADMIN";
      }
      return this.form.role === "SUPER ADMIN";
    },
  },
  mounted: async function () {
    let routerName = this.$route.name;
    
    console.log("route param data:", this.$route.params.data);
    let editData = this.$route.params.data;
    

    await this.fetchFeedData();

    if (routerName == "UUser") {
      if (editData != null) {
        this.mode = "UPDATE";
        this.form.role = editData.roles;
        this.form.status = this.statusOptions.find(s => s.value === editData.status);

        if (editData.product_category) {
          const productItems = editData.product_category;
          const result = productItems.map((item) => ({ name: item }));

          this.value = result;

          const matchedItems = this.value
            .map((product) => {
              return this.options.find(
                (option) => option.name === product.name
              );
            })
            .filter((match) => match !== undefined);

          this.value = [...matchedItems];
        }
        console.log("role", this.form.role);
        console.log("status", this.form.status);
        console.log("product", this.value);
        

        this.updateId = editData.id;
      } else {
        //No Data, No View Page
        this.$router.go(-1);
      }
    }
  },
  watch: {
    options(newVal) {
      if (newVal.length > 0) {
        console.log("Options from watcher:", newVal[0]);
        // this.processOptions(newVal[0]); // Call another method with the updated value
      }
    },
    // roles(newRole) {
    //   if (newRole === "SUPER ADMIN") {
    //     // Add all product IDs to product_category
    //     this.form.product_category = this.options.map((product) => product.id);
    //   } else {
    //     // Clear product_category when not SUPER ADMIN
    //     this.form.product_category = [];
    //   }
    // },
  },
  methods: {
    async fetchFeedData() {
      try {
        const token = this.user.token;
        const headers = {
          Authorization: `Bearer ${token}`,
        };

        const endpoints = [
          "/api/admin/feeds/product-category",
          `/api/admin/feeds/roles`, // cari env
        ];

        const resps = await Promise.all(
          endpoints.map((url) => this.$httpSSO.get(url, { headers }))
        );

        const productCategories = resps[0].data.data.map((prod) => ({
          id: prod.id,
          name: prod.name,
        }));

        const roles = resps[1].data.data.map((role) => (
         role.name
        ));

        this.options.push(...productCategories);
        this.roles.push(...roles);
        console.log("roles:", this.roles);
        
      } catch (error) {
        console.error("Error fetching product category feeds", error);
      } 
  },
    goBack() {
      this.$router.go(-1); // Go back to the previous route
    },
    performSearch() {
      // Implement your search logic here using this.searchQuery
      // For example, you can filter your data based on the search query
    },
    validateForm() {
      let errors = [];

      if (this.form.product_category.length === 0) {
        errors.push("<strong>Product type</strong> is a required field!");
      }

      if (errors.length > 0) {
        this.$swal.fire({
          title: "Error!",
          icon: "error",
          type: "error",
          html: errors.join("<br>"),
        });
        console.log("errors:", errors);
        return false;
      } else {
        console.log("errors:", errors);
        return true;
      }
    },
    submitForm() {
      const token = this.user.token;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      if (typeof this.form.role === "object" && this.form.role !== null) {
          this.form.role = this.form.role.name;
      }
     if (this.form.role === "SUPER ADMIN") {
        this.form.product_category = this.options.map((product) => product.id);
      } else {
        const productsId = this.value.map((product) => product.id);
        this.form.product_category = productsId;
      }
      this.form.status = this.form.status.value;

      if (this.form.role === "SUPER ADMIN" || this.validateForm()) {
        this.$swal
          .fire({
            title: "Are you sure?",
            text: `You are about to ${
              this.mode == "CREATE" ? "make a new" : "edit current"
            } data`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085D6",
            cancelButtonColor: "#D33",
            confirmButtonText: "Simpan",
          })
          .then((result) => {
            if (result.value) {
              let url =
                this.mode == "CREATE"
                  ? "/api/admin/user"
                  : "/api/admin/user/" + this.updateId; // Fix the typo here
              let method = this.mode == "CREATE" ? "post" : "put";

              this.$httpSSO[method](url, this.form, { headers })
                .then((resp) => {
                  this.$swal.fire({
                    title: "Success!",
                    icon: "success",
                    type: "success",
                    text: `${
                      this.mode == "CREATE"
                        ? "Berhasil menambahkan user baru"
                        : "Berhasil melakukan update"
                    }`,
                  });
                  this.$router.go(-1); // Go back to the previous route
                })
                .catch((error) => {
                  console.log(
                    "%cerror DashboardUserUM.vue line:78 ",
                    "color: red; display: block; width: 100%;",
                    error
                  );
                  this.$swal.fire({
                    title: "Error!",
                    icon: "error",
                    type: "error",
                    text: error.response.data.message,
                  });
                });
            }
          });
      }
    },
  },
};
</script>

<style scoped>
/* .dropdown-menu {
  width: auto; /* Ensures the width adapts
} */
/* max-width: 300px; Optional: Limit maximum width */

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  padding-left: 40px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #4d4d4d;
}

/* .center {
          padding: 50px 20px;
          display: flexbox;
          flex-direction: column;
          align-items: center;
          justify-content: center;
      } */

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table td,
.table th {
  text-align: center;
}

.news-image-1 img {
  max-width: 100%;
  /* To make the image smaller and responsive */
}

.news-title-1 {
  text-align: left;
  /* To position the news-title on the top right */
}

.news-content-1 {
  text-align: left;
  /* To position the news-content on the bottom right */
}

.search-container {
  display: flex;
  align-items: center;
}

.dropdown-container {
  flex: 1;
  margin-right: 10px;
}

.searchbar-container {
  flex: 2;
}

.dropdown {
  width: 100%;
}

.searchbar {
  width: 100%;
  padding: 5px;
  height: 42px;  
  padding: 10px 14px; 
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  box-sizing: border-box;
}

.form-text {
    font-family: 'Inter',sans-serif;
    color: #4B4B4B;
    font-size: 14px;
    font-weight: 400;
}
.multiselect {
  width: 100%;
  box-sizing: border-box;
}

</style>
<style>
.dropdown-custom .multiselect__placeholder,
.dropdown-custom .multiselect__input::placeholder {
  font-family: 'Inter', sans-serif !important;
  font-size: 14px !important;
  color: #BEBEBE !important;
}


.dropdown-custom .multiselect__single {
  font-family: 'Inter',sans-serif;
  font-size: 14px !important;
  color: #4B4B4B !important; 
}

.dropdown-custom .multiselect__option {
  font-family: 'Inter',sans-serif;
  font-size: 14px !important;
}
.multiselect__element{
  font-family: 'Inter',sans-serif;
  color: #4B4B4B !important; 
  font-size: 14px !important;
}</style>
